import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const copyToClipboard = (text: string) => {
  window.navigator.clipboard.writeText(text).then(() => {
    alert('Copied to clipboard!');
  });
};
